import { render, staticRenderFns } from "./Tipo.vue?vue&type=template&id=121cea84&scoped=true"
import script from "./Tipo.vue?vue&type=script&lang=js"
export * from "./Tipo.vue?vue&type=script&lang=js"
import style0 from "./Tipo.vue?vue&type=style&index=0&id=121cea84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121cea84",
  null
  
)

export default component.exports